<template>
  <shop-list
    :extra="extra"
    :title="title"
  ></shop-list>
</template>

<script>
import ShopList from '@/components/ShopList'
import MetaInfoBuilder from '@/utils/social'
import { oldEvents } from '@/views/events/events'

export default {
  components: {
    ShopList,
  },
  data: () => ({
    extra: oldEvents,
    title: 'Shop',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>
